import React, { LegacyRef } from 'react';



export interface TopControlProps {
    inputOnChange: (e: any) => void;
    airlineSelectChange: (e: any) => void;
    citySelectOnChange: (e: any) => void;
    TerminalSelectedOnChange: (e: any) => void;
    toggleAD: (e: boolean) => void;
    toggleCodeShares: (e: any) => void;
    showCodeShares: boolean;
    airlineList: string[];
    cityList: string[];
    isArrival: boolean;
}


export const TopControlF = React.forwardRef((props: TopControlProps, ref: React.Ref<HTMLInputElement>) => (
    <div>
                <div id='top_form' className='row'>
                    <div className='col'>
                        <h1 className='SearchBoxTitle'>Flight Search</h1>
                    </div>
                </div>

                <form onSubmit={e => e.preventDefault()}>
                    <div className='form-row justify-content-center'>
                        <div className='form-group col-md-3' />
                        <div className='form-group col-md-6'>
                            <input
                                ref={ref}
                                className='form-control'
                                type='text'
                                id='main_search_input'
                                onChange={props.inputOnChange}
                                placeholder='Enter Airline, City or Flight #'
                                onClick={e => e.preventDefault()}
                            />
                        </div>
                        <div className='form-group col-md-3' />
                        <div className='form-group col-md-4'>
                            <div className='input-group-3'>
                                <select
                                    className='custom-select'
                                    onChange={props.airlineSelectChange}>
                                    <option value=''>Select Airline</option>
                                    {props.airlineList.map(
                                        (item, index) => (
                                            <option key={item} value={item}>
                                                {item}
                                            </option>
                                        ),
                                    )}
                                </select>
                            </div>
                        </div>
                        <div className='form-group col-md-4'>
                            <div className='input-group-3'>
                                <select
                                    className='custom-select'
                                    onChange={props.citySelectOnChange}>
                                    <option value=''>Select City</option>
                                    {props.cityList.map((item, index) => (
                                        <option key={item} value={item}>
                                            {item}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className='form-group col-md-4'>
                            <div className='input-group-3'>
                                <select
                                    className='custom-select'
                                    onChange={props.TerminalSelectedOnChange}>
                                    <option value=''>Select Terminal</option>
                                    <option value='2'>Terminal 2</option>
                                    <option value='3'>Terminal 3</option>
                                    <option value='4'>Terminal 4</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </form>
                <div className='row justify-content-center mb-4'>
                    <div className='col-xs-auto'>
                        <div
                            className='custom-control custom-radio custom-control-inline'
                            onClick={() => props.toggleAD(true)}>
                            <input
                                className='custom-control-input'
                                checked={props.isArrival}
                                onChange={() => {}}
                                value={props.isArrival.toString()}
                                type='radio'
                            />
                            <label className='custom-control-label'>
                                Arrivals
                            </label>
                        </div>
                        <div
                            className='custom-control custom-radio custom-control-inline'
                            onClick={() => props.toggleAD(false)}>
                            <input
                                className='custom-control-input'
                                checked={!props.isArrival}
                                onChange={() => {}}
                                type='radio'
                                value={(!props.isArrival).toString()}
                            />
                            <label className='custom-control-label'>
                                Departure
                            </label>
                        </div>
                    </div>
                    <div className='col-xs-auto'>
                        <div className='custom-control custom-checkbox'>
                            <input
                                className='custom-control-input'
                                type='checkbox'
                                id='customCheck12'
                                onChange={props.toggleCodeShares}
                                checked={props.showCodeShares}
                                value={props.showCodeShares.toString()}
                            />
                            <label
                                className='custom-control-label'
                                htmlFor='customCheck12'>
                                Show Codeshare Flights
                            </label>
                        </div>
                    </div>
                </div>

                <div className='row'>
                    <div className='col-sm-auto'>
                        <h5>
                            {props.isArrival
                                ? 'Arriving  Flights'
                                : 'Departing Flights'}
                        </h5>
                    </div>
                </div>
            </div>
));


